var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"emr",staticStyle:{"border":"none","margin-top":"5px"},attrs:{"seamless":"","src":_vm.url,"width":"98%","height":"98%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }